module.exports = __webpack_public_path__ + "static/media/logo.f630807a.png";